require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-nicola-navone-bellinzona-1960-1970-progetti-per-la-citta-e-il-territorio-monte-carasso-5-luglio-2021.json") })
        }
      }, "path---relazioni-e-conferenze-nicola-navone-bellinzona-1960-1970-progetti-per-la-citta-e-il-territorio-monte-carasso-5-luglio-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-nicola-navone-bellinzona-1960-1970-progetti-per-la-citta-e-il-territorio-monte-carasso-5-luglio-2021!./.cache/json/relazioni-e-conferenze-nicola-navone-bellinzona-1960-1970-progetti-per-la-citta-e-il-territorio-monte-carasso-5-luglio-2021.json
// module id = 718
// module chunks = 231608221292675